import {css} from "@emotion/css";
import React, {useRef, useState} from "react";
import useDraggableScroll from "use-draggable-scroll";
import PropTypes from "prop-types";
import "./RaikoSelectBox.scss"

export const RaikoSelectBox = ({items = [], changeSelectItem, defaultSelectedItem, className}) => {

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});

    const [selectedItemId, setSelectedItemId] =
        useState(
            defaultSelectedItem ? defaultSelectedItem :
                items[0].id ? items[0].id
                    : -1);


    function handleNewSelect(id) {
        setSelectedItemId(id)
        changeSelectItem(id)
        console.log("id is ... ",id)
    }

    return (
        <section className={`raikoSelectBoxContainer ${className}`} ref={ref} onMouseDown={onMouseDown}>

            {items.map((item, listIndex) => {
                return <div
                    key={listIndex}
                    className={`raikoSelectBoxItems  
                            ${selectedItemId === item.id && "raikoSelectBoxItemActive "}`}
                    onClick={_ => handleNewSelect(item.id)}>

                    <div className={css`
                      border-radius: var(--default-border-radius);
                      width: fit-content;
                      height: fit-content;
                    `} id="filesIconContainer">
                        <div className={`${css`
                          padding: 20px;
                        `} ${item.icon}`}
                             id="filesIcon"
                        />
                    </div>

                    <p id="filesTitle">{item.title}</p>
                </div>
            })}


        </section>
    )
}

RaikoSelectBox.propTypes = {
    items: PropTypes.array.isRequired,
    changeSelectItem: PropTypes.func.isRequired
}

export function prepareRaikoSelectBoxItem(id, title, iconClass = "ic-files") {
    return {
        id,
        title,
        icon: iconClass
    }
}